import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { toast } from "react-toastify"
import { useUserMergeLineItemsMutation } from "../../../services/ExpenseApi"
import { FaEye } from "react-icons/fa6"
import ReactReadMoreReadLess from "react-read-more-read-less";
import Lightbox from 'react-image-lightbox'


type Props = {
  show: boolean
  handleClose: () => void
  onConfirm: () => void
  selectedDraftData?: any
  selectedBankItemData?: any
  refetch?: () => void
  onMainModalClose?: () => void
  onSuccess?: () => void
}

interface LightboxData {
  imageURL: string;
}

const MergeLineItemModal = ({
  show,
  handleClose,
  onConfirm,
  selectedDraftData,
  selectedBankItemData,
  refetch,
  onMainModalClose,
  onSuccess,
}: Props) => {
  const [mergeLineItem, { data, isSuccess, isError, error, isLoading, reset }] =
    useUserMergeLineItemsMutation()

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' });
  const [hasProcessedSuccess, setHasProcessedSuccess] = useState(false)
  const [isConfirmed, setIsConfirmed] = useState(false)

  const isPdfFile = (filePath: string | undefined) => {
    if (!filePath) return false;
    const fileExtension = filePath.toLowerCase().split('.').pop();
    return fileExtension === 'pdf';
  };
  const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
    if (attachmentFile) {
      if (isPdfFile(attachmentFile)) {
        window.open(attachmentFile, '_blank');
      } else {
        setLightboxData({ imageURL: attachmentFile });
        setLightboxOpen(true);
      }
    }
  };

  const handleMergeLineItem = async () => {
    try {
      await mergeLineItem({
        CCExpenseItemID: selectedBankItemData?.expenseItemId,
        SSExpenseItemID: selectedDraftData?.expenseItemId,
      })
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if (isSuccess && !hasProcessedSuccess) {
      setHasProcessedSuccess(true)
      console.log('comnsole')

      const responseData = (data as any)?.message
      toast.success(responseData)
      if (refetch) refetch()
      // Call onSuccess callback to refresh inner table data
      if (onSuccess) onSuccess()
      // Close confirmation modal and then main modal
      handleClose()
      onConfirm()
    }
  }, [isSuccess, hasProcessedSuccess])

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = "Something went wrong"
      if (
        "data" in error &&
        error.data &&
        typeof error.data === "object" &&
        "message" in error.data
      ) {
        errorMessage = (error.data as { message: string }).message
      }
      toast.error(errorMessage)
    }
  }, [isError, error])

  React.useEffect(() => {
    if (show) {
      setHasProcessedSuccess(false)
      setIsConfirmed(false)
    }
  }, [show, selectedDraftData, selectedBankItemData])

  // Reset mutation state when modal closes to clean up for next time
  React.useEffect(() => {
    if (!show) {
      reset()
    }
  }, [show, reset])

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">Confirm Merge</h5>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
        ></button>
      </div>

      <div className="modal-body">
        <p className="mb-4 fs-5">
          Are you sure you want to merge this expense with the selected bank
          line item?
        </p>

        {selectedDraftData && selectedBankItemData && (
          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
            <thead className="">
              <tr>
                <th style={{ width: "20%" }}>Label</th>
                <th style={{ width: "40%" }}>Mob / Web</th>
                <th style={{ width: "40%" }}>Bank</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Expense Type</strong></td>
                <td>{selectedDraftData?.expenseType?.title || "N/A"}</td>
                <td>{selectedBankItemData?.expenseType?.title || "---"}</td>
              </tr>
              <tr>
                <td><strong>Date</strong></td>
                <td>{selectedDraftData?.itemDate?.split("T")[0] || "N/A"}</td>
                <td>{selectedBankItemData?.itemDate?.split("T")[0] || "N/A"}</td>
              </tr>
              <tr>
                <td><strong>Amount</strong></td>
                <td>${selectedDraftData?.amount || "N/A"}</td>
                <td>${selectedBankItemData?.amount || "N/A"}</td>
              </tr>
              <tr>
                <td><strong>Vendor</strong></td>
                <td>{selectedDraftData?.vendor?.name || "N/A"}</td>
                <td>{selectedBankItemData?.vendor?.name || "N/A"}</td>
              </tr>
              <tr>
                <td><strong>Payment Method</strong></td>
                <td>{selectedDraftData?.paymentMethod?.title || "N/A"}</td>
                <td>{selectedBankItemData?.paymentMethod?.title || "N/A"}</td>
              </tr>
              <tr>
                <td><strong>Attachment</strong></td>
                {/* <td>
                  {selectedDraftData?.attachmentFile ? (
                    <a
                      href={selectedDraftData.attachmentFile}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaEye className='' />

                    </a>
                  ) : (
                    "---"
                  )}
                </td> */}
                <td>
                  {selectedDraftData.attachmentFile ? (<>
                    <FaEye className='' onClick={() => openPdfInBrowserOrLightbox(selectedDraftData.attachmentFile)} />
                    {lightboxOpen && (
                      <Lightbox
                        mainSrc={lightboxData.imageURL}
                        onCloseRequest={() => setLightboxOpen(false)}
                        imageCaption="Attachment"
                        enableZoom={true}
                        imagePadding={50}
                      />
                    )}
                  </>
                  ) : 'N/A'}
                </td>
                {/* <td>
                  {selectedBankItemData?.attachmentFile ? (
                    <a
                      href={selectedBankItemData.attachmentFile}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaEye className='' />
                    </a>
                  ) : (
                    "---"
                  )}
                </td> */}
                <td>
                  {selectedBankItemData.attachmentFile ? (<>
                    <FaEye className='' onClick={() => openPdfInBrowserOrLightbox(selectedBankItemData.attachmentFile)} />
                    {lightboxOpen && (
                      <Lightbox
                        mainSrc={lightboxData.imageURL}
                        onCloseRequest={() => setLightboxOpen(false)}
                        imageCaption="Attachment"
                        enableZoom={true}
                        imagePadding={50}
                      />
                    )}
                  </>
                  ) : 'N/A'}
                </td>
              </tr>
              <tr>
                <td><strong>Description</strong></td>

                <td className='text-wrap'>
                  {/* {data?.itemDetail?.length > 60 ? `${data?.itemDetail.substring(0, 40)}...` : data?.itemDetail} */}
                  {selectedDraftData?.itemDetail && <ReactReadMoreReadLess
                    charLimit={30}
                    readMoreText={"Read more"}
                    readLessText={"Read less"}
                    readMoreClassName="readMore"
                    readLessClassName="readLess"
                  >
                    {selectedDraftData?.itemDetail}
                  </ReactReadMoreReadLess>}
                </td>

                <td className='text-wrap'>
                  {/* {data?.itemDetail?.length > 60 ? `${data?.itemDetail.substring(0, 40)}...` : data?.itemDetail} */}
                  {selectedBankItemData?.itemDetail && <ReactReadMoreReadLess
                    charLimit={30}
                    readMoreText={"Read more"}
                    readLessText={"Read less"}
                    readMoreClassName="readMore"
                    readLessClassName="readLess"
                  >
                    {selectedBankItemData?.itemDetail}
                  </ReactReadMoreReadLess>}
                </td>



              </tr>
            </tbody>
          </table>
        )}
      </div>

      <div className="modal-footer d-flex flex-column align-items-start">
        <div className="form-check mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            id="confirmCheckbox"
            checked={isConfirmed}
            onChange={(e) => setIsConfirmed(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="confirmCheckbox">
            I confirm that I want to proceed with this merge.
          </label>
        </div>

        <div className="d-flex w-100 justify-content-end">
          <button className="btn btn-light me-2" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleMergeLineItem}
            disabled={isLoading || !isConfirmed}
          >
            {!isLoading && "Confirm Merge"}
            {isLoading && (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Merging...
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default MergeLineItemModal